import { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import StatisticsService from "../../../services/statistics.service";
import StatDescriptionTooltip from "./StatDescriptionTooltip";
import StatAsyncContent from "./StatAsyncContent";
import StatLineChart from "./StatLineChart";

export default function ActiveMembershipsByYearStat() {
  const [data, setData] = useState(null);
  const [description, setDescription] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    StatisticsService.getActiveMembershipsByYear().then(({ data, description, error }) => {
      if (error) setError(error);
      else {
        setData(
          (data ?? []).map((item) => ({
            year: item.year,
            total: item.total_users_with_active_membership,
          }))
        );
        setDescription(description);
      }
    });
  }, []);

  return (
    <Card sx={{ flex: 1, minWidth: 320 }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 2 }}>
          <Typography variant="h6">Membresías activas por año</Typography>
          <StatDescriptionTooltip description={description} />
        </Box>

        <StatAsyncContent error={error} loading={data === null}>
          <StatLineChart
            data={data}
            xKey="year"
            stroke="#1976d2"
            labelFormatter={(year) => `Año ${year}`}
          />
        </StatAsyncContent>
      </CardContent>
    </Card>
  );
}
